import { render, staticRenderFns } from "./Diaocha.vue?vue&type=template&id=6216d09c"
import script from "./Diaocha.vue?vue&type=script&lang=js"
export * from "./Diaocha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports